import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
// import LogUser from "../../granular/LogActivity/logUser.js";
// import LogLocation from "../../granular/LogActivity/logLocation.js";
import LogActivity from "../../granular/LogActivity/logActivity.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { pushLoader } from "../../actions/main/index.js";

import {
  fetchAlert,
  fetchLogActivity,
  fetchLogActivityPeriode,
  pushAlert,
  deleteAlert,
  updateAlert
} from "../../api/logactivity";

import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  },
  container: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    justifyContent: "center"
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 200,
    padding: 5
  }
});

class Logactivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateAlert: "",
      company_code: "",
      title: "",
      description: "",
      datatable: [],
      openAdd: false,
      openEdit: false,
      id: 0,
      loader: null,
      startDate: moment()
        .subtract(1, "hours")
        .format("YYYY-MM-DDTHH:mm:ss"),
      endDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
      totalData: 100,
      searchText: "",
      keyword: null
    };
  }

  componentDidMount = async () => {
    // let startdate = new Date(moment().format("YYYY-MM-DD"));
    // startdate.setDate(startdate.getDate() - 1);

    // let endDate = new Date(moment().format("YYYY-MM-DD"));

    // this.setState({
    //   startDate: moment(startdate).format("YYYY-MM-DD"),
    //   endDate: moment(endDate).format("YYYY-MM-DD")
    // });
    this.props.pushLoader(true);
    await this.handleSearch(10, 0);
    this.props.pushLoader(false);
    // fetchLogActivity()
    //   .then(response => {
    //     if (response != null) {
    //       this.setState({ datatable: response.data.results });
    //       console.log(this.state.datatable, "logg");
    //     }
    //     this.props.pushLoader(false);
    //     this.setState({ loader: false });
    //   })
    //   .catch(error => {
    //     //this.props.pushToken(error);
    //   });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleSearchClick = () => {
    this.setState({ searchCheck: true });
    this.handleSearch(10, 0);
  };

  handleKeyword = async e => {
    await this.setState({ keyword: e });
    await this.handleSearch(10, 0);
  };

  handleSearch = async (row, page, text) => {
    // if (text !== undefined) {
    //   this.setState({ searchText: text });
    // } else {
    //   this.setState({ searchText: "" });
    // }

    // if (text === null) {
    //   this.setState({ searchText: "" });
    // } else {
    //   this.setState({ searchText: text });
    // }
    this.setState({ loader: true, datatable: [] });
    await fetchLogActivityPeriode(
      this.state.startDate.replace("T", " "),
      this.state.endDate.replace("T", " "),
      row,
      page * row,
      // this.state.searchText,
      this.state.keyword ? this.state.keyword : ""
    )
      .then(response => {
        this.setState({
          datatable: response.data.results,
          totalData: response.data.total
        });
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
    this.setState({ loader: false });
  };

  handleCheckSearch = () => {
    this.setState({ searchCheck: false });
  };

  getDatatable = () => {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchLogActivityPeriode(this.state.startDate, this.state.endDate)
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleShow = event => {
    event.preventDefault();
    this.getDatatable();
  };

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Log Activity</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <GridItem xs={10} sm={10} md={10}>
              <Card>
                <CardContent>
                  <form className={classes.container} noValidate>
                    <FormControl
                      size="small"
                      style={{
                        paddingBottom: 6,
                        display: "flex",
                        flexDirection: "row"
                      }}
                    >
                      <TextField
                        size="small"
                        id="datetime-local"
                        label="Start Date"
                        type="datetime-local"
                        className={classes.textField}
                        defaultValue={this.state.startDate}
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          value: this.state.startDate,
                          onChange: this.handleStartDate
                        }}
                      />
                      <TextField
                        size="small"
                        id="datetime-local"
                        label="End Date"
                        type="datetime-local"
                        className={classes.textField}
                        defaultValue={this.state.endDate}
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          value: this.state.endDate,
                          onChange: this.handleEndDate
                        }}
                      />
                    </FormControl>
                    <FormControl
                      size="small"
                      style={{
                        paddingBottom: 6,
                        display: "flex"
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="behance"
                        round
                        onClick={this.handleSearchClick}
                      >
                        Show
                      </Button>
                    </FormControl>
                  </form>
                </CardContent>
              </Card>
            </GridItem>
            {/* <GridItem xs={10} sm={10} md={10}>
              <LogLocation/>
            </GridItem>
            <GridItem xs={10} sm={10} md={10}>
              <LogUser/>
            </GridItem> */}
            <GridItem xs={10} sm={10} md={10}>
              <br />
              <LogActivity
                datatable={this.state.datatable}
                handleDelete={this.handleDelete}
                restate={this.restate}
                loader={this.state.loader}
                handleSearch={this.handleSearch}
                handleCheckSearch={this.handleCheckSearch}
                totalData={this.state.totalData}
                handleKeyword={this.handleKeyword}
                keyword={this.state.keyword}
              />
            </GridItem>
          </Grid>
        </Grid>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(
  mapStateToProps,
  { pushLoader }
)(withStyles(styles)(Logactivity)));
